module.exports = __webpack_public_path__ + "6613e3c7f62630409bb1077931aee24a.svg";